import { Component, ViewChild } from '@angular/core';
import { Platform, Nav, Content } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

@Component({
  templateUrl: 'app.html'
})
export class EMS_Web {
  
  @ViewChild(Nav) nav: Nav;

  rootPage:any = "Registration";

  private language: string;

  constructor(platform: Platform, private translate: TranslateService, private http: HttpClient) {

    let instance = this;

    this.http.get("assets/config.json").subscribe(function(response: any) {
      instance.translate.setDefaultLang("cht");
      instance.translate.use(response.defaultLang);
      instance.language = response.defaultLang;
    });
    
    this.translate.getTranslation("eng");
    this.translate.getTranslation("cht");

  }

  private openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
  }

  private changeLanguage(language: string) {

    this.translate.use(language);

  }
  
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts